export default {
  install(Vue, options) {
    Vue.prototype.getImgUrl = function (src) {
      return 'http://api.shgg.ltd/' + src;
    };
  }
};